import Api from '../../services/Api';

export default () => {
    const url = '/gestao/aviso-sincronizacao';

    return Api.get(url);
};
